// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Amatic+SC&family=Economica&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors (palette)*/
  --col-black: rgb(20, 20, 20);
  --col-white: rgb(255, 255, 255);
  --col-grey: rgb(150, 150, 150);

  --dark-purple: #191021;
  --indigo-dye: #294a6d;
  --cerulean: #37779a;
  --moonstone: #6aa0aa;
  --magenta-dye: #c02d74;

  --header-linear-gradient: linear-gradient(
    330deg,
    var(--dark-purple),
    var(--indigo-dye),
    var(--cerulean),
    var(--magenta-dye)
  );

  --footer-linear-gradient: linear-gradient(
    210deg,
    var(--dark-purple),
    var(--indigo-dye),
    var(--cerulean),
    var(--moonstone)
  );

  --footer-linear-gradient-mobile: linear-gradient(
    210deg,
    var(--indigo-dye),
    var(--cerulean),
    var(--moonstone),
    var(--moonstone)
  );

  --footer-bg-poligon-mobile: polygon(0 0, 100% 0, 100% 30%, 0 60%);
  --footer-bg-poligon-mobile-landscape: polygon(0 0, 50% 0, 25% 100%, 0 100%);
  --footer-bg-poligon-tablet: polygon(0 0, 100% 0, 100% 40%, 0 75%);
  --footer-bg-poligon-desktop: polygon(0 0, 100% 0, 100% 50%, 0 100%);

  /* Colors (background)*/
  --bg-col: var(--col-white);

  /* Colors (text/icons)*/
  --col-txt: var(--col-black);
  --col-txt-alt: var(--col-white);
  --col-txt-p: var(--col-grey);

  /* Font family */
  --main-font: "Economica", sans-serif;
  --h1-font: "Economica", sans-serif;
  --h2-font: "Amatic SC", monospace;

  /* Font sizes */
  --txt-fontsize: max(18px, 3vmin);
  --txt-lineheight: 1.2;

  --h1-fontsize: 3.5rem;
  --h2-fontsize: 2rem;
  --h3-fontsize: 1.1rem;
  --project-description-fontsize: 0.8rem;

  --social-icons-size: 1.8rem;
  --project-icons-size: calc(var(--h3-fontsize) * var(--txt-lineheight));

  /* Maximum width (including dashboard margin) */
  --max-width: min(1440px, 100%);

  /*Margins, gaps and paddings (+widths)*/
  --social-icons-gap: 0.5rem;
  --my-work-title-gap: 1rem;
  --my-work-list-gap: 1.5rem;

  --project-info-padding: 1rem 0.5rem 0.5rem;
  --project-info-gap: 0.5rem;
  --project-icons-gap: 0;

  /* > mobile styles*/

  --page-padding-mobile: 1rem;
  --page-delta-padding-mobile: 1rem;
  --h1-padding-mobile: 0 var(--page-delta-padding-mobile)
    var(--page-delta-padding-mobile);

  --about-me-padding-mobile: 1rem 0;
  --about-me-padding-mobile-landscape: 0 1rem 0 2rem;
  --about-me-description-padding-mobile: 1rem 0;

  --my-work-padding-mobile: 0;
  --my-work-padding-mobile-landscape: 0;

  --my-work-ncol-mobile: 1;
  --my-work-ncol-mobile-landscape: 2;

  --contact-me-padding-mobile: 2rem var(--page-padding-mobile);
  --contact-me-padding-mobile-landscape: 2rem var(--page-padding-mobile);

  --contact-me-gap-mobile: 1.5rem;

  /* > tablet styles*/
  --page-padding-tablet: 1rem;
  --page-delta-padding-tablet: 1rem;
  --h1-padding-top-tablet: 5vh;
  --h1-padding-bottom-tablet: 3vh;
  --h1-padding-tablet: var(--h1-padding-top-tablet) 0
    var(--h1-padding-bottom-tablet);

  --about-me-padding-top-tablet: 3rem;
  --about-me-padding-left-right-tablet: 1rem;
  --about-me-padding-tablet: var(--about-me-padding-top-tablet)
    var(--about-me-padding-left-right-tablet) 3rem;

  --about-me-description-padding-top-tablet: 1rem;
  --about-me-description-padding-tablet: var(
      --about-me-description-padding-top-tablet
    )
    0 1rem;

  --my-work-padding-tablet: 0 var(--page-delta-padding-mobile);
  --my-work-ncol-tablet: 2;

  --contact-me-padding-tablet: 2rem 1rem 2rem 0;
  --contact-me-gap-tablet: 1.5rem;

  /* > desktop styles*/

  --page-padding-desktop: 2rem;
  --page-delta-padding-desktop: 2rem;
  --h1-padding-desktop: 0 var(--page-delta-padding-desktop) 1rem;

  --about-me-padding-left-right-desktop: 1rem;
  --about-me-padding-desktop: 3rem var(--about-me-padding-left-right-desktop)
    3rem
    calc(
      var(--about-me-padding-left-right-desktop) +
        var(--page-delta-padding-desktop)
    );
  --about-me-description-padding-desktop: 1rem 0 1rem;

  --my-work-padding-desktop: 0;
  --my-work-ncol-desktop: 3;

  --contact-me-padding-desktop: 2rem 1rem 2rem 0;
  --contact-me-gap-desktop: 1.5rem;

  /* Radius / borders */
  --box-border: max(2px, 0.3vmin) solid var(--col-black);
  --box-radius: max(6px, 0.9vmin);

  /* Shadows */
  --txt-shadow: 0 3px 6px var(--col-black), 2px 0px 2px var(--col-black);
  --box-shadow: 0 3px 9px var(--col-grey);
  --box-shadow-darker: 0 3px 9px var(--col-black);
  --box-shadow-hover: var(--box-shadow-darker);

  --box-scale-hover: 1.06;

  /* Animations on hover / active / ...*/
  /* --transition-time: 0.8s; */
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/variables.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;;EAE9B,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;;EAEtB;;;;;;GAMC;;EAED;;;;;;GAMC;;EAED;;;;;;GAMC;;EAED,iEAAiE;EACjE,2EAA2E;EAC3E,iEAAiE;EACjE,mEAAmE;;EAEnE,uBAAuB;EACvB,0BAA0B;;EAE1B,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;;EAE5B,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,iCAAiC;;EAEjC,eAAe;EACf,gCAAgC;EAChC,qBAAqB;;EAErB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;;EAEtC,2BAA2B;EAC3B,sEAAsE;;EAEtE,+CAA+C;EAC/C,8BAA8B;;EAE9B,uCAAuC;EACvC,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;;EAE1B,0CAA0C;EAC1C,0BAA0B;EAC1B,sBAAsB;;EAEtB,mBAAmB;;EAEnB,2BAA2B;EAC3B,iCAAiC;EACjC;oCACkC;;EAElC,iCAAiC;EACjC,kDAAkD;EAClD,6CAA6C;;EAE7C,2BAA2B;EAC3B,qCAAqC;;EAErC,wBAAwB;EACxB,kCAAkC;;EAElC,4DAA4D;EAC5D,sEAAsE;;EAEtE,+BAA+B;;EAE/B,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;EAC5B,+BAA+B;EAC/B;mCACiC;;EAEjC,mCAAmC;EACnC,0CAA0C;EAC1C;kDACgD;;EAEhD,+CAA+C;EAC/C;;;UAGQ;;EAER,4DAA4D;EAC5D,wBAAwB;;EAExB,6CAA6C;EAC7C,+BAA+B;;EAE/B,oBAAoB;;EAEpB,4BAA4B;EAC5B,kCAAkC;EAClC,8DAA8D;;EAE9D,2CAA2C;EAC3C;;;;;KAKG;EACH,mDAAmD;;EAEnD,4BAA4B;EAC5B,yBAAyB;;EAEzB,8CAA8C;EAC9C,gCAAgC;;EAEhC,qBAAqB;EACrB,sDAAsD;EACtD,+BAA+B;;EAE/B,YAAY;EACZ,sEAAsE;EACtE,uCAAuC;EACvC,+CAA+C;EAC/C,4CAA4C;;EAE5C,uBAAuB;;EAEvB,sCAAsC;EACtC,6BAA6B;AAC/B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Amatic+SC&family=Economica&display=swap\");\r\n\r\n:root {\r\n  /* Colors (palette)*/\r\n  --col-black: rgb(20, 20, 20);\r\n  --col-white: rgb(255, 255, 255);\r\n  --col-grey: rgb(150, 150, 150);\r\n\r\n  --dark-purple: #191021;\r\n  --indigo-dye: #294a6d;\r\n  --cerulean: #37779a;\r\n  --moonstone: #6aa0aa;\r\n  --magenta-dye: #c02d74;\r\n\r\n  --header-linear-gradient: linear-gradient(\r\n    330deg,\r\n    var(--dark-purple),\r\n    var(--indigo-dye),\r\n    var(--cerulean),\r\n    var(--magenta-dye)\r\n  );\r\n\r\n  --footer-linear-gradient: linear-gradient(\r\n    210deg,\r\n    var(--dark-purple),\r\n    var(--indigo-dye),\r\n    var(--cerulean),\r\n    var(--moonstone)\r\n  );\r\n\r\n  --footer-linear-gradient-mobile: linear-gradient(\r\n    210deg,\r\n    var(--indigo-dye),\r\n    var(--cerulean),\r\n    var(--moonstone),\r\n    var(--moonstone)\r\n  );\r\n\r\n  --footer-bg-poligon-mobile: polygon(0 0, 100% 0, 100% 30%, 0 60%);\r\n  --footer-bg-poligon-mobile-landscape: polygon(0 0, 50% 0, 25% 100%, 0 100%);\r\n  --footer-bg-poligon-tablet: polygon(0 0, 100% 0, 100% 40%, 0 75%);\r\n  --footer-bg-poligon-desktop: polygon(0 0, 100% 0, 100% 50%, 0 100%);\r\n\r\n  /* Colors (background)*/\r\n  --bg-col: var(--col-white);\r\n\r\n  /* Colors (text/icons)*/\r\n  --col-txt: var(--col-black);\r\n  --col-txt-alt: var(--col-white);\r\n  --col-txt-p: var(--col-grey);\r\n\r\n  /* Font family */\r\n  --main-font: \"Economica\", sans-serif;\r\n  --h1-font: \"Economica\", sans-serif;\r\n  --h2-font: \"Amatic SC\", monospace;\r\n\r\n  /* Font sizes */\r\n  --txt-fontsize: max(18px, 3vmin);\r\n  --txt-lineheight: 1.2;\r\n\r\n  --h1-fontsize: 3.5rem;\r\n  --h2-fontsize: 2rem;\r\n  --h3-fontsize: 1.1rem;\r\n  --project-description-fontsize: 0.8rem;\r\n\r\n  --social-icons-size: 1.8rem;\r\n  --project-icons-size: calc(var(--h3-fontsize) * var(--txt-lineheight));\r\n\r\n  /* Maximum width (including dashboard margin) */\r\n  --max-width: min(1440px, 100%);\r\n\r\n  /*Margins, gaps and paddings (+widths)*/\r\n  --social-icons-gap: 0.5rem;\r\n  --my-work-title-gap: 1rem;\r\n  --my-work-list-gap: 1.5rem;\r\n\r\n  --project-info-padding: 1rem 0.5rem 0.5rem;\r\n  --project-info-gap: 0.5rem;\r\n  --project-icons-gap: 0;\r\n\r\n  /* > mobile styles*/\r\n\r\n  --page-padding-mobile: 1rem;\r\n  --page-delta-padding-mobile: 1rem;\r\n  --h1-padding-mobile: 0 var(--page-delta-padding-mobile)\r\n    var(--page-delta-padding-mobile);\r\n\r\n  --about-me-padding-mobile: 1rem 0;\r\n  --about-me-padding-mobile-landscape: 0 1rem 0 2rem;\r\n  --about-me-description-padding-mobile: 1rem 0;\r\n\r\n  --my-work-padding-mobile: 0;\r\n  --my-work-padding-mobile-landscape: 0;\r\n\r\n  --my-work-ncol-mobile: 1;\r\n  --my-work-ncol-mobile-landscape: 2;\r\n\r\n  --contact-me-padding-mobile: 2rem var(--page-padding-mobile);\r\n  --contact-me-padding-mobile-landscape: 2rem var(--page-padding-mobile);\r\n\r\n  --contact-me-gap-mobile: 1.5rem;\r\n\r\n  /* > tablet styles*/\r\n  --page-padding-tablet: 1rem;\r\n  --page-delta-padding-tablet: 1rem;\r\n  --h1-padding-top-tablet: 5vh;\r\n  --h1-padding-bottom-tablet: 3vh;\r\n  --h1-padding-tablet: var(--h1-padding-top-tablet) 0\r\n    var(--h1-padding-bottom-tablet);\r\n\r\n  --about-me-padding-top-tablet: 3rem;\r\n  --about-me-padding-left-right-tablet: 1rem;\r\n  --about-me-padding-tablet: var(--about-me-padding-top-tablet)\r\n    var(--about-me-padding-left-right-tablet) 3rem;\r\n\r\n  --about-me-description-padding-top-tablet: 1rem;\r\n  --about-me-description-padding-tablet: var(\r\n      --about-me-description-padding-top-tablet\r\n    )\r\n    0 1rem;\r\n\r\n  --my-work-padding-tablet: 0 var(--page-delta-padding-mobile);\r\n  --my-work-ncol-tablet: 2;\r\n\r\n  --contact-me-padding-tablet: 2rem 1rem 2rem 0;\r\n  --contact-me-gap-tablet: 1.5rem;\r\n\r\n  /* > desktop styles*/\r\n\r\n  --page-padding-desktop: 2rem;\r\n  --page-delta-padding-desktop: 2rem;\r\n  --h1-padding-desktop: 0 var(--page-delta-padding-desktop) 1rem;\r\n\r\n  --about-me-padding-left-right-desktop: 1rem;\r\n  --about-me-padding-desktop: 3rem var(--about-me-padding-left-right-desktop)\r\n    3rem\r\n    calc(\r\n      var(--about-me-padding-left-right-desktop) +\r\n        var(--page-delta-padding-desktop)\r\n    );\r\n  --about-me-description-padding-desktop: 1rem 0 1rem;\r\n\r\n  --my-work-padding-desktop: 0;\r\n  --my-work-ncol-desktop: 3;\r\n\r\n  --contact-me-padding-desktop: 2rem 1rem 2rem 0;\r\n  --contact-me-gap-desktop: 1.5rem;\r\n\r\n  /* Radius / borders */\r\n  --box-border: max(2px, 0.3vmin) solid var(--col-black);\r\n  --box-radius: max(6px, 0.9vmin);\r\n\r\n  /* Shadows */\r\n  --txt-shadow: 0 3px 6px var(--col-black), 2px 0px 2px var(--col-black);\r\n  --box-shadow: 0 3px 9px var(--col-grey);\r\n  --box-shadow-darker: 0 3px 9px var(--col-black);\r\n  --box-shadow-hover: var(--box-shadow-darker);\r\n\r\n  --box-scale-hover: 1.06;\r\n\r\n  /* Animations on hover / active / ...*/\r\n  /* --transition-time: 0.8s; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
